var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.839966H2C0.9 0.839966 0 1.73997 0 2.83997V16.84C0 17.94 0.9 18.84 2 18.84H20C21.1 18.84 22 17.94 22 16.84V2.83997C22 1.73997 21.1 0.839966 20 0.839966ZM11 8.83997H2V6.83997H11V8.83997ZM11 4.83997H2V2.83997H11V4.83997Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid8);
export default __webpack_public_path__ + "static/media/grid8.56ed615916e1c6ad66a5c8ef9be7634c.svg";
export { ForwardRef as ReactComponent };